export const discountCategory = {
	title: "Discount Categories",
	label: "Create, edit, delete, activate or deactivate discount categories",
	search: {
		label: "Search",
		placeholder: "Search discount category name",
	},
	filter: {
		label: "Filter by",
		placeholder: "Choose filter",
	},
	create: "Create new category",
	allCategories: "All discount categories",
	activeCategories: "Active Discount Categories",
	inactiveCategories: "Inactive Discount Categories",
	errorNotification: "Please select a location first",
	drawer: {
		edit: "Edit Discount Category",
		create: "Create discount category",
	},
	form: {
		name: {
			label: "Category Name",
			placeholder: "Give the discount category a name",
		},
		discount: {
			label: "Discount given in",
			value: "Reais",
			percentage: "Percent",
		},
		stabilizedType: {
			label: "Established",
			fixed: "Fixed value",
			range: "Range",
		},
		employees: {
			label: "Employees authorized to use the category",
			placeholder: "Search by name",
		},
		between: "Between",
		and: "and",
		errors: {
			name: "Please enter a valid name",
			stabilizedType: "Select an option above",
			employees: "Select an employee",
		},
		observation: "Notes",
		addObservation: "Allow adding note",
	},
	modal: {
		title: "Delete discount category",
		message: "Do you want to delete the category of '{{name}}'?",
	},
	table: {
		status: "STATUS",
		name: "DISCOUNT CATEGORY NAME",
		discountType: "DISCOUNT GIVEN ON",
		value: "RANGE OR FIXED VALUE",
		showEmployees: "View employees with permission",
		hideEmployees: "Hide employees with permission",
		emptyText: "Looks like you haven't created a discount category yet",
		editCategory: "Edit Discount Category",
		removeCategory: "Delete Discount Category",
		employee: "Employee with Permission",
		loading: "Loading",
	},
};
